import { ReactNode } from "react";

interface SourceBannerProps {
  icon?: ReactNode;
  title: string;
  text: string;
}

const SourceBanner = ({ icon = "?", title, text }: SourceBannerProps) => {
  return (
    <div className="sourceBanner">
      <div className="sbIcon">{icon}</div>
      <div className="sbText">
        <strong>{title}</strong>
        {text}
      </div>
    </div>
  );
};

export default SourceBanner;
